export default __webpack_public_path__ + "static/media/External-Project.682fece5.png";